import React, { ChangeEvent, useState } from 'react';
import { ENABLE_ONE_TIME_FEATURES } from '@zola-helpers/client/dist/es/util/userSettings';
import {
  getLocalStorage,
  setLocalStorage,
  deleteLocalStorage,
} from '@zola-helpers/client/dist/es/util/storage';

import styles from './FeatureToggle.module.less';

import CheckBoxField from '../Form/CheckboxField/CheckboxField';

export const UserSettingsOverride = (): JSX.Element => {
  const [overrideUserSettings, setOverrideUserSettings] = useState(
    Boolean(getLocalStorage(ENABLE_ONE_TIME_FEATURES))
  );

  const handleUserSettingsOverrideClick = (e: ChangeEvent<HTMLInputElement>) => {
    setOverrideUserSettings(e.target.checked);
    if (e.target.checked) setLocalStorage(ENABLE_ONE_TIME_FEATURES, 'true');
    else deleteLocalStorage(ENABLE_ONE_TIME_FEATURES);

    window.location.reload();
  };

  return (
    <CheckBoxField
      className={styles.userSettings}
      id="disableUserSettings"
      inline
      label="Enable all one-time features (e.g. tours/modals)"
      onChange={handleUserSettingsOverrideClick}
      checked={overrideUserSettings}
    />
  );
};
